/* unplugin-vue-components disabled */import { render } from "./CollectHome.vue?vue&type=template&id=f3bb72f0&scoped=true"
import script from "./CollectHome.vue?vue&type=script&lang=js"
export * from "./CollectHome.vue?vue&type=script&lang=js"

import "./CollectHome.vue?vue&type=style&index=0&id=f3bb72f0&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3bb72f0"]])

export default __exports__